import { CORNER_EXTRA_LARGE, CORNER_SMALL } from "~/common/components/icon/Corners";
import { ELEVATION_1 } from "~/common/components/icon/Elevation";
import { OverlayContent, OverlayHeader } from "~/common/components/Overlay/Overlay";
import { Box, Grid, Stack, styled } from "~/common/mui";
import { MediasLogo } from "~/features/navigation/components/TopBar/MediasLogo";
import { LOGIN_RIGHT_IMAGE } from "~/utils/url/staticResources";
interface ContentWrapperProps {
  singleColumn?: boolean;
}

const OVERLAY_MAX_WIDTH = "1920px";
const RIGHT_TEXT_CONTAINER_WIDTH = "567px";
export const FORM_CONTAINER_WIDTH = "420px";

export const OverlayHeaderStyled = styled(OverlayHeader)(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: OVERLAY_MAX_WIDTH,
  width: "100%",
  margin: "0 auto",
}));

export const HeaderActions = styled(Stack)({
  flexDirection: "row",
  justifyContent: "flex-end",
});

export const StyledOverlayContent = styled(OverlayContent)(({ theme }) => ({
  display: "flex",
  height: "calc(100dvh - 80px)",
  justifyContent: "center",
  overflowY: "auto",
  padding: theme.spacing(2),
  WebkitOverflowScrolling: "touch",
  "&:last-child": {
    paddingBottom: 0,
  },
  [theme.breakpoints.up("desktop-s")]: {
    height: "calc(100dvh - 152px)",
    padding: `0 ${theme.spacing(2)}`,
  },
  maxWidth: OVERLAY_MAX_WIDTH,
  width: "100%",
  margin: "0 auto",
}));

export const LogoRow = styled(Stack)({
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "center",
});

export const StyledStack = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  gap: theme.spacing(2),
}));

export const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "singleColumn",
})<ContentWrapperProps>(({ theme, singleColumn }) => ({
  alignItems: "center",
  display: "grid",
  gap: theme.spacing(3),
  gridTemplateColumns: "1fr",
  height: "100%",
  justifyItems: "center",
  maxWidth: OVERLAY_MAX_WIDTH,
  width: "100%",
  [theme.breakpoints.up("desktop-s")]: {
    gridTemplateColumns: singleColumn ? "1fr" : "1fr 1fr",
    justifyItems: "stretch",
  },
}));

export const LeftSection = styled(Stack)(({ theme }) => ({
  alignItems: "stretch",
  height: "calc(100dvh - 80px)",
  justifySelf: "center",
  justifyContent: "flex-start",
  marginBlock: 0,
  maxWidth: "100%",
  minHeight: 0,
  overflowY: "auto",
  padding: `0 ${theme.spacing(2)} ${theme.spacing(4)}`,
  WebkitOverflowScrolling: "touch",
  width: "100%",
  "& > *": {
    marginBlock: "auto",
  },
  [theme.breakpoints.up("tablet")]: {
    height: "auto",
    marginBlock: "auto",
    overflowY: "visible",
    padding: `0 ${theme.spacing(4)}`,
  },
  [theme.breakpoints.up("desktop-s")]: {
    height: "calc(100dvh - 152px)",
    marginBlock: 0,
    maxWidth: "592px",
    overflowY: "auto",
    padding: theme.spacing(2),
  },
}));

export const FormContainer = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  background: theme.palette.surface.bright,
  borderRadius: CORNER_EXTRA_LARGE,
  boxShadow: ELEVATION_1,
  gap: theme.spacing(2),
  justifyContent: "center",
  padding: theme.spacing(3),
  width: "100%",
  [theme.breakpoints.up("tablet")]: {
    width: FORM_CONTAINER_WIDTH,
  },
}));

export const FormGrid = styled(Grid)({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
});

export const OverlayActionsSpacer = styled(Box)(({ theme }) => ({
  display: "none",
  flexShrink: 0,
  height: "72px",
  [theme.breakpoints.up("desktop-s")]: {
    display: "block",
  },
}));

export const RightImage = styled(Stack)(({ theme }) => ({
  alignItems: "flex-end",
  background: `url("${LOGIN_RIGHT_IMAGE}") center / cover no-repeat`,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${CORNER_EXTRA_LARGE} 0 0 ${CORNER_EXTRA_LARGE}`,
  display: "none",
  height: "100%",
  position: "relative",
  width: `calc(100% + ${theme.spacing(2)})`,
  [theme.breakpoints.up("desktop-s")]: {
    display: "flex",
  },
  [theme.breakpoints.up("desktop-l")]: {
    borderRadius: CORNER_EXTRA_LARGE,
    width: "100%",
  },
}));

export const RightTextContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  position: "absolute",
  bottom: "96px",
  left: "0",
  maxWidth: RIGHT_TEXT_CONTAINER_WIDTH,
  minHeight: "160px",
  padding: "24px 42px 24px 26px",
  borderRadius: `0 ${CORNER_SMALL} ${CORNER_SMALL} 0`,
  borderLeft: `16px solid ${theme.palette.primary.main}`,
  background: "rgba(255, 255, 255, 0.8)",
  backdropFilter: "blur(14px)",
  zIndex: 1,
  width: RIGHT_TEXT_CONTAINER_WIDTH,
}));

export const StyledMediasLogo = styled(MediasLogo)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.divider}`,
  paddingRight: theme.spacing(1),
  height: "12px !important",
}));
